import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthenticatedAdmin } from '../providers/AuthenticatedAdminProvider';
import NavigationBar from '../components/NavigationBar';

export const AuthenticatedAdminPage = () => {
  const { authenticatedAdmin } = useAuthenticatedAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticatedAdmin) {
      navigate('/admins/sign_in');
    }
  }, [authenticatedAdmin, navigate]);

  if (!authenticatedAdmin) {
    return null;
  }

  return (
    <div>
      <NavigationBar authenticatedAdmin={authenticatedAdmin} />
      <div style={{ padding: 12 }}>
        <Outlet />
      </div>
    </div>
  );
};

export default AuthenticatedAdminPage;
